<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/about/corporate-profile',
    'fr-CA': '/a-propos-kpt/profile'
  }
})

useHead({
  title: t('navigation.corporateProfile.metatitle'),
  meta: [{ name: 'description', content: t('navigation.corporateProfile.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('about-about')">{{ $t('navigation.about.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.corporateProfile.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.corporateProfile.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuAbout />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <p>KP Tissue Inc. is a publicly traded company that currently holds a {{ $t('global.pourcentage-KP-inc') }}% interest in Kruger Products Inc., the operating company.</p>
            <p>Kruger Products Inc. is Canada's leading manufacturer of quality tissue products for the Consumer market (Cashmere®, Purex®, SpongeTowels®, Scotties®, White Swan® and Bonterra<sup>TM</sup>) and the Away-From-Home market, and continues to grow in the U.S. Consumer tissue business with the White Cloud® brand and premium private label products.</p>
            <p>Kruger Products Inc. is headquartered in Mississauga, Ontario and has approximately 3,000 employees across North America. Kruger Products Inc. operates a total of ten&nbsp;FSC® COC-certified (FSC® C104904) production facilities, including six plants, five&nbsp;of which are located in Canada and one in the U.S. Three of the production facilities are converting&nbsp;only.</p>
            <p>Kruger Products Inc.’s Canadian paper manufacturing facilities, consisting of four tissue plants in Québec and one plant in British Columbia, have a combined annual tissue production capacity of approximately 350,000 metric tonnes which, according to RISI data, represents approximately 44% of Canada’s annual production&nbsp;capacity.</p>
            <p>Kruger Products Inc.'s&nbsp;Memphis Plant, held through KTG, a wholly-owned subsidiary, consists of one conventional light dry crepe paper machine&nbsp;with an aggregate annual capacity of 30,000 metric tonnes (the “Initial Memphis Operations”), and one adjacent 55,000 metric tonne state-of-the-art TAD tissue machine (the “Memphis TAD&nbsp;Machine”).</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <p>Papiers Tissu KP inc. est une société cotée en bourse qui détient actuellement une participation de {{ $t('global.pourcentage-KP-inc') }}&nbsp;% dans Produits Kruger inc., la société d’exploitation.</p>
            <p>Produits Kruger inc. est le premier fabricant canadien de produits de papier de qualité destinés aux consommateurs (Cashmere<sup>MD</sup>, Purex<sup>MD</sup>, SpongeTowels<sup>MD</sup>, Scotties<sup>MD</sup>,White Swan<sup>MD</sup>&nbsp;et Bonterra<sup>MD</sup>) et au marché hors foyer. Elle continue aussi à croître aux États-Unis grâce à la marque White Cloud<sup>MD</sup> et à d’autres marques privées de qualité supérieure.</p>
            <p>Produits Kruger inc., dont le siège social est situé à Mississauga, en Ontario, compte environ 3 000 employés à travers l’Amérique du Nord. Produits Kruger inc. exploite un total de dix&nbsp;installations de production certifiées FSC® COC (FSC®&nbsp;C104904), y compris six&nbsp;usines de fabrication dont cinq&nbsp;sont situées au Canada et une aux États-Unis. Trois des installations de production de la Société se consacrent uniquement à la&nbsp;transformation.</p>
            <p>Les usines canadiennes de fabrication de papier de Produits Kruger inc., qui consistent en trois usines de papier tissu au Québec et une usine en Colombie-Britannique, ont une capacité de production de papier annuelle combinée d’environ 350 000 tonnes métriques, soit, selon les données de RISI, environ 44&nbsp;% de la capacité de production annuelle du&nbsp;Canada.</p>
            <p>L’usine de Produits Kruger inc. de Memphis, au Tennessee, détenue par le biais de KTG, une filiale en propriété exclusive, regroupe une machine&nbsp;conventionnelle&nbsp;à papier léger crêpé à sec d’une capacité annuelle globale de 30 000 tonnes métriques (les «&nbsp;activités de production initiales de Memphis&nbsp;») et une machine contiguë à papier tissu TAD de pointe d’une capacité de 55 000 tonnes métriques (la «&nbsp;machine TAD de&nbsp;Memphis&nbsp;»).&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
